import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg backdrop-blur-md' : 'bg-transparent'}`}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_inventory-manager-30/artifacts/sis1j2zy_logo.png" 
              alt="RESET Logo" 
              className="h-10 w-auto"
            />
            <div className="text-2xl font-bold text-gray-800">RESET</div>
          </div>
          
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="#inicio" onClick={() => scrollToSection('inicio')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Inicio</a>
            <a href="#caracteristicas" onClick={() => scrollToSection('caracteristicas')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Características</a>
            <a href="#beneficios" onClick={() => scrollToSection('beneficios')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Beneficios</a>
            <a href="#dashboard" onClick={() => scrollToSection('dashboard')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Dashboard</a>
            <a href="#testimonios" onClick={() => scrollToSection('testimonios')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Testimonios</a>
            <a href="#precios" onClick={() => scrollToSection('precios')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Precios</a>
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <Button variant="ghost" className="text-gray-700 hover:text-blue-600">
              Iniciar Sesión
            </Button>
            <Button className="bg-blue-600 hover:bg-blue-700 text-white">
              Solicitar Demo
            </Button>
          </div>

          <button 
            className="lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t">
            <nav className="flex flex-col space-y-4 mt-4">
              <a href="#inicio" onClick={() => scrollToSection('inicio')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Inicio</a>
              <a href="#caracteristicas" onClick={() => scrollToSection('caracteristicas')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Características</a>
              <a href="#beneficios" onClick={() => scrollToSection('beneficios')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Beneficios</a>
              <a href="#dashboard" onClick={() => scrollToSection('dashboard')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Dashboard</a>
              <a href="#testimonios" onClick={() => scrollToSection('testimonios')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Testimonios</a>
              <a href="#precios" onClick={() => scrollToSection('precios')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Precios</a>
              <div className="flex flex-col space-y-2 pt-4 border-t">
                <Button variant="ghost" className="text-gray-700 hover:text-blue-600 justify-start">
                  Iniciar Sesión
                </Button>
                <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                  Solicitar Demo
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;